module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<header><h5>Recipients</h5></header><div class="notification-recipients" data-region="container"></div><div class="button-wrap text-left"><small><a href="#" data-click="recipient-create">'+
((__t=( i18n.tc("Recipients", "Add new recipient?") ))==null?'':__t)+
'</a></small></div><div class="button-wrap"><button data-click="recipients-cancel">'+
((__t=( i18n.tc("Recipients", "Cancel") ))==null?'':__t)+
'</button></div>';
}
return __p;
};
